module.exports = __webpack_public_path__ + "static/saratogaspringsdoodles-f575180408fc85a42e2abdc8265779c7.webp";